import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button, Container, Popover, PopoverBody,
} from 'reactstrap';
import { Text } from 'recharts';
import InformationOutlineIcon from 'mdi-react/InformationOutlineIcon';
import '../../../stylesheets/customStyles.css';

const PopoverRight = ({ dir, contents, id }) => {
  const [IsOpenedPopover, setIsOpenedPopover] = useState(false);

  const handleOpenPopover = () => {
    setIsOpenedPopover(!IsOpenedPopover);
  };

  return (
    <div>
      <InformationOutlineIcon size="1.2em" style={{ marginBottom: '0.2em' }} />
      <Text id={id} onClick={handleOpenPopover}> Click for more</Text>
      <Popover
        style={{ maxWidth: '500px' }}
        placement="right"
        isOpen={IsOpenedPopover}
        target={id}
        toggle={handleOpenPopover}
        dir={dir}
      >
        <PopoverBody onClick={handleOpenPopover}>
          {contents}
        </PopoverBody>
      </Popover>
    </div>

  );
};

PopoverRight.propTypes = {
  dir: PropTypes.string.isRequired,
  contents: PropTypes.node.isRequired,
  id: PropTypes.string.isRequired,
};

export default PopoverRight;
